const SimulationDat = {
  GrineerAgentCapture: {
    path: "/Lotus/Types/Gameplay/Eidolon/Jobs/ReclamationBountyCap",
    name: "CAPTURE THE GRINEER AGENT",
    description:
      "An item of great importance to the Quills has been taken by the Grineer. Locate the agent who stole it and bring him in.",
    icon: "/Lotus/Interface/Quests/EidolonNew/TwoFistedArchJob.png",
    stages: {
      initial: [
        "Assassination",
        "Drone",
        "Liberate The Camp",
        "Armored Vault",
        "Rescue",
        "Cache",
      ],
      final: ["Capture"],
    },
  },
  ArtifactRecovery: {
    path: "/Lotus/Types/Gameplay/Eidolon/Jobs/ReclamationBountyCache",
    name: "FIND THE HIDDEN ARTIFACT",
    description:
      "The Grineer have taken an Orokin artifact. Find where they have stashed it.",
    icon: "/Lotus/Interface/Quests/EidolonNew/TwoFistedArchJob.png",
    stages: {
      initial: [
        "Assassination",
        "Drone",
        "Liberate TheCamp",
        "Armored Vault",
        "Rescue",
        "Capture",
      ],
      final: ["Cache", "Cave Cache"],
    },
  },
};

export default SimulationDat;
